import { render } from "./InspirationView.vue?vue&type=template&id=d9f6cdee&ts=true"
import script from "./InspirationView.vue?vue&type=script&lang=ts"
export * from "./InspirationView.vue?vue&type=script&lang=ts"

import "./InspirationView.vue?vue&type=style&index=0&id=d9f6cdee&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__